import { Box, Button, FormControl, Grid, Icon, InputLabel, MenuItem, Paper, Select, Typography } from "@mui/material";
import { DialogConfirm } from '../../shared/components/dialog/DialogConfirm';
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { LinearProgress } from "@mui/material";
import { FormHandles } from "@unform/core";
import * as yup from 'yup';

import { AlertSnackBar, FerramentaDeDetalhe } from "../../shared/components"
import { LayoutBaseDePagina } from "../../shared/layouts"
import { VTextField, VForm, useVForm } from "../../shared/forms";
import { ClienteService } from "../../shared/services/api/cliente/ClienteService";
import { Environment } from "../../shared/environment";
import { CampoTextoMascarado } from "../../shared/components/campo-texto-mascarado/CampoTextoMascarado";


interface IFormData {
    cnpj: string;
    nome: string;
}

const formValidationSchema: yup.SchemaOf<IFormData> = yup.object().shape({
    cnpj: yup.string().required("Digite um CNPJ").min(14, "Digite todos os números do CNPJ"),
    nome: yup.string().required('Nome é obrigatório'),
});

export const DetalheDeCliente = () => {
    const { cnpj = 'novo' } = useParams<'cnpj'>();
    const navigate = useNavigate();

    const [alert, setAlert] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
    const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

    const [nome, setNome] = useState('');

    const [errorCnpj, setErrorCnpj] = useState(false);

    const [maskedCnpj, setMaskedCnpj] = useState('');
    const handleChangeCnpj = (valorMascarado: string) => {
        setMaskedCnpj(valorMascarado);
        setErrorCnpj(false);
    };

    const { formRef, save, saveAndReturn, isSaveAndReturn } = useVForm();

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (cnpj !== 'novo') {
            setIsLoading(true);
            setNome("Carregando...")

            ClienteService.getByCnpj(cnpj).then((result) => {
                setIsLoading(false);
                if (result instanceof Error) {
                    // se der erro, volta para a listagem para não ficar uma tela em branco
                    setAlert({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlert(undefined);
                    }, duracaoAlert);
                } else {
                    setNome(result.nome);

                    formRef.current?.setData(result);
                }
            });

        } else {
            formRef.current?.setData({
                nome: ''
            })
        }
    }, [cnpj])

    const limparCampos = () => {
        formRef.current?.setData({
            nome: '',
        });
        setMaskedCnpj('');
    }

    const handleSave = (dados: IFormData) => {
        setIsLoading(true);

        //retirar a máscara
        if (cnpj === "novo") {
            let unmaskedCnpj = maskedCnpj.replaceAll('.', '');
            unmaskedCnpj = unmaskedCnpj.replace('/', '');
            unmaskedCnpj = unmaskedCnpj.replace('-', '');
            unmaskedCnpj = unmaskedCnpj.replaceAll('_', '');
            dados.cnpj = unmaskedCnpj;
        } else {
            dados.cnpj = cnpj;
        }

        formValidationSchema.validate(dados, { abortEarly: false }).then(() => {
            if (cnpj === 'novo') {

                ClienteService.create(dados).then((result) => {
                    setIsLoading(false);
                    if (result instanceof Error) {
                        setAlert({ tipoAlert: "erro", mensagem: result.message });
                        setTimeout(() => {
                            setAlert(undefined);
                        }, duracaoAlert);
                    } else {
                        setAlert({ tipoAlert: "sucesso", mensagem: "Unidade cadastrada" });
                        setTimeout(() => {
                            setAlert(undefined);
                        }, duracaoAlert);

                        if (isSaveAndReturn()) {
                            navigate(-1)
                        } else {
                            limparCampos();
                        }

                    }
                });
            } else {
                ClienteService.updateByCnpj(dados).then((result) => {
                    setIsLoading(false);
                    if (result instanceof Error) {
                        setAlert({ tipoAlert: "erro", mensagem: result.message });
                        setTimeout(() => {
                            setAlert(undefined);
                        }, duracaoAlert);
                    } else {
                        setNome(dados.nome);

                        setAlert({ tipoAlert: "sucesso", mensagem: "Unidade atualizada" });
                        setTimeout(() => {
                            setAlert(undefined);
                        }, duracaoAlert);

                        if (isSaveAndReturn()) {
                            navigate(-1)
                        }
                    }
                });
            }
        }).catch((errors: yup.ValidationError) => {
            const validationErrors: { [key: string]: string } = {};

            errors.inner.forEach(error => {
                if (!error.path) return;

                validationErrors[error.path] = error.message;
                if (error.path === "cnpj") setErrorCnpj(true);
            });

            formRef.current?.setErrors(validationErrors);
            setIsLoading(false);

        });
    }
    const handleDelete = () => {
        setAbrir(false);
        ClienteService.toggleEnabledByCnpj(cnpj)
            .then(result => {
                if (result instanceof Error) {//verificar se deu erro
                    setAlert({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlert(undefined);
                    }, duracaoAlert);
                } else {
                    setAlert({ tipoAlert: "sucesso", mensagem: "Unidade desativada" });
                    setTimeout(() => {
                        setAlert(undefined);
                    }, duracaoAlert);
                    navigate('/cliente')
                }
            });
    }

    const [abrir, setAbrir] = useState(false);
    const handleCancel = () => {
        setAbrir(false);
    }

    return (
        <LayoutBaseDePagina
            titulo={cnpj == 'novo' ? 'Novo unidade' : nome}
            barraDeFerramentas={
                <FerramentaDeDetalhe
                    mostrarBotaoSalvarEVoltar
                    mostrarBotaoApagar={cnpj !== 'novo'}
                    mostrarBotaoNovo={cnpj !== 'novo'}

                    mostrarBotaoNovoCarregando={isLoading}
                    mostrarBotaoApagarCarregando={isLoading}
                    mostrarBotaoSalvarCarregando={isLoading}
                    mostrarBotaoSalvarEVoltarCarregando={isLoading}

                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEVoltar={saveAndReturn}
                    aoClicarEmApagar={() => setAbrir(true)}
                    aoClicarEmNovo={() => navigate('/cliente/detalhe/novo')}
                    aoClicarEmVoltar={() => navigate(-1)}
                />
            }
        >
            {isLoading && (
                <LinearProgress variant="indeterminate" />
            )}

            <DialogConfirm
                AoConfirmar={handleDelete}
                titulo={"Dejesa realmente desativar a unidade?"}
                texto={"Ao confirmar, a unidade e tudo que o pertence será desativado, para defazer a ação será necessário reativar-lo na listagem de unidade desativada."}
                abrir={abrir}
                AoCancelar={handleCancel}
            />

            {alert !== undefined && (
                <>
                    {alert.tipoAlert === "sucesso" && (
                        <AlertSnackBar gravidade="success" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                    {alert.tipoAlert === "erro" && (
                        <AlertSnackBar gravidade="error" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                    {alert.tipoAlert === "aviso" && (
                        <AlertSnackBar gravidade="warning" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                    )}
                </>
            )}

            <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                <VForm ref={formRef} onSubmit={handleSave}>
                    <Grid container direction="column" padding={2} spacing={2}>

                        <Grid container item direction="row" spacing={2}>

                            {cnpj == 'novo' && (<Grid item xs={12} sm={12} md={4} lg={2}>
                                <CampoTextoMascarado
                                    fullWidth
                                    mask="99.999.999/9999-99"
                                    label="CNPJ"
                                    name="CNPJ"
                                    disabled={isLoading}
                                    error={errorCnpj}
                                    helperText={errorCnpj && "Digite todos os números do cnpj"}
                                    value={maskedCnpj}
                                    onChange={(valorMascarado) => handleChangeCnpj(valorMascarado)}
                                />
                            </Grid>
                            )}
                        </Grid>
                        <Grid container item direction="row" spacing={2}>
                            <Grid item xs={12} sm={12} md={6} lg={4}>
                                <VTextField name="nome" fullWidth label="Nome" placeholder="Digite o nome..." disabled={isLoading} />
                            </Grid>

                        </Grid>
                    </Grid>
                </VForm>

            </Box>

        </LayoutBaseDePagina>
    )
}
